import * as React from 'react'
import { ArrayUtils } from '@shopping/common'
import { styling } from 'common/utils'
import { Menu, FlagType, DynamicCx } from 'common/types'
import {
  getSubVerticalPath,
  getVerticalName,
  getVerticalPath,
  SubVertical,
  subVerticalConfig,
  Vertical,
  verticalConfig,
} from 'common/constants'
import LnbLink from './LnbLink'
import { LnbSearch } from '../Search'
import { getHomeUrl } from 'common/utils/url'
import * as s from './lnb.scss'

const pcMenus: Menu[] = [
  {
    title: getVerticalName(Vertical.HOME),
    to: getHomeUrl(false),
    className: 'lnb_home',
    nclick: '@N=a:LNB.home',
    vertical: Vertical.HOME,
  },
  {
    title: getVerticalName(Vertical.DEPARTMENT),
    to: getVerticalPath(Vertical.DEPARTMENT),
    className: 'lnb_depart',
    nclick: '@N=a:LNB.wdep',
    vertical: Vertical.DEPARTMENT,
  },
  {
    title: getVerticalName(Vertical.OUTLET),
    to: getVerticalPath(Vertical.OUTLET),
    className: 'lnb_oulet',
    nclick: '@N=a:LNB.wout',
    vertical: Vertical.OUTLET,
  },
  {
    title: getVerticalName(Vertical.STYLE),
    to: getSubVerticalPath(SubVertical.STYLE),
    className: 'lnb_style',
    nclick: '@N=a:LNB.wstl',
    vertical: Vertical.STYLE,
    subMenus: [
      {
        title: subVerticalConfig.STYLE.name,
        to: getSubVerticalPath(SubVertical.STYLE),
        className: 'sub_roadshop',
        nclick: '@N=a:LNB.roadshop',
        subVertical: SubVertical.STYLE,
      },
      {
        title: subVerticalConfig.FASHION_BRAND.name,
        to: getSubVerticalPath(SubVertical.FASHION_BRAND),
        className: 'sub_brandshop',
        nclick: '@N=a:LNB.brand',
        subVertical: SubVertical.FASHION_BRAND,
      },
    ],
  },
  {
    title: getVerticalName(Vertical.DESIGNER),
    to: getVerticalPath(Vertical.DESIGNER),
    className: 'lnb_designer',
    nclick: '@N=a:LNB.wdsn',
    vertical: Vertical.DESIGNER,
  },
  {
    title: getVerticalName(Vertical.BEAUTY),
    to: getVerticalPath(Vertical.BEAUTY),
    className: 'lnb_beauty',
    nclick: '@N=a:LNB.beautywindow',
    vertical: Vertical.BEAUTY,
  },
  {
    title: getVerticalName(Vertical.LIVING),
    to: getVerticalPath(Vertical.LIVING),
    className: 'lnb_living',
    nclick: '@N=a:LNB.wliving',
    vertical: Vertical.LIVING,
    subMenus: [
      {
        title: subVerticalConfig.HOME_LIVING.name,
        to: getSubVerticalPath(SubVertical.HOME_LIVING),
        className: 'sub_homeliving',
        nclick: '@N=a:LNB.homeliving',
        subVertical: SubVertical.HOME_LIVING,
      },
      {
        title: subVerticalConfig.HANDMADE.name,
        to: getSubVerticalPath(SubVertical.HANDMADE),
        className: 'sub_handmade',
        nclick: '@N=a:LNB.handmade',
        subVertical: SubVertical.HANDMADE,
      },
      {
        title: subVerticalConfig.STATIONERY.name,
        to: getSubVerticalPath(SubVertical.STATIONERY),
        className: 'sub_stationery',
        nclick: '@N=a:LNB.stationery',
        flag: { type: FlagType.NEW, className: 'sub_new' },
        subVertical: SubVertical.STATIONERY,
      },
    ],
  },
  {
    title: getVerticalName(Vertical.FRESH),
    to: getVerticalPath(Vertical.FRESH),
    className: 'lnb_fresh',
    nclick: '@N=a:LNB.fresh',
    vertical: Vertical.FRESH,
    subMenus: [
      {
        title: subVerticalConfig.DIRECT_FARM.name,
        to: getSubVerticalPath(SubVertical.DIRECT_FARM),
        className: 'sub_producer',
        nclick: '@N=a:LNB.wsanji',
        subVertical: SubVertical.DIRECT_FARM,
      },
      {
        title: subVerticalConfig.LOCAL_FOOD.name,
        to: getSubVerticalPath(SubVertical.LOCAL_FOOD),
        className: 'sub_region',
        nclick: '@N=a:LNB.wlocal',
        subVertical: SubVertical.LOCAL_FOOD,
      },
      {
        title: subVerticalConfig.TRADITIONAL_ALCOHOL.name,
        to: getSubVerticalPath(SubVertical.TRADITIONAL_ALCOHOL),
        className: 'sub_alcohol',
        nclick: '@N=a:LNB.walcohol',
        subVertical: SubVertical.TRADITIONAL_ALCOHOL,
      },
      {
        title: subVerticalConfig.HOME_MEAL.name,
        to: getSubVerticalPath(SubVertical.HOME_MEAL),
        className: 'sub_cooking',
        nclick: '@N=a:LNB.whomemeal',
        subVertical: SubVertical.HOME_MEAL,
      },
    ],
  },
  {
    title: getVerticalName(Vertical.KIDS),
    to: getVerticalPath(Vertical.KIDS),
    className: 'lnb_kids',
    nclick: '@N=a:LNB.wkids',
    vertical: Vertical.KIDS,
  },
  {
    title: getVerticalName(Vertical.PET),
    to: getVerticalPath(Vertical.PET),
    className: 'lnb_pet',
    nclick: '@N=a:LNB.pet',
    vertical: Vertical.PET,
  },
  {
    title: getVerticalName(Vertical.PLAY),
    to: getVerticalPath(Vertical.PLAY),
    className: 'lnb_play',
    nclick: '@N=a:LNB.wplay',
    vertical: Vertical.PLAY,
  },
  {
    title: getVerticalName(Vertical.ART),
    to: getVerticalPath(Vertical.ART),
    className: 'lnb_art',
    nclick: '@N=a:LNB.wart',
    vertical: Vertical.ART,
  },
  {
    title: getVerticalName(Vertical.HOTDEAL),
    to: `${getVerticalPath(Vertical.HOTDEAL)}/p/index.nhn`,
    className: 'lnb_hotdeal',
    nclick: '@N=a:LNB.hotdeal',
    vertical: Vertical.HOTDEAL,
    subMenus: [
      {
        title: subVerticalConfig.SOCIAL.name,
        to: '/hotdeal/p/social/index.nhn',
        className: 'sub_social',
        nclick: '@N=a:LNB.socialbest',
        subVertical: SubVertical.SOCIAL,
      },
      {
        title: subVerticalConfig.LUCKTO.name,
        to: '/hotdeal/p/luckto/best.nhn',
        className: 'sub_lucky',
        nclick: '@N=a:LNB.luckytoday',
        subVertical: SubVertical.LUCKTO,
      },
    ],
  },
  {
    title: getVerticalName(Vertical.FOREIGN),
    to: getVerticalPath(Vertical.FOREIGN),
    className: 'lnb_foreign',
    nclick: '@N=a:LNB.globalwindow',
    vertical: Vertical.FOREIGN,
  },
  {
    title: getVerticalName(Vertical.PLAN),
    to: '/plan2/p/index.nhn',
    className: 'lnb_theme',
    nclick: '@N=a:LNB.theme',
    vertical: Vertical.PLAN,
  },
]

const getRollingClass = (vertical: Vertical): string => {
  const currentMenu = pcMenus.find(menu => menu.vertical === vertical)
  return currentMenu && ArrayUtils.isNotEmpty(currentMenu.subMenus) ? 'rolling' : ''
}

interface State {
  rollingClass: string
  marginLeft: number
}

interface OwnProps {
  vertical?: Vertical
  cx?: DynamicCx
}

type Props = OwnProps

@styling(s)
export default class Lnb extends React.PureComponent<Props, State> {
  menuArea: React.RefObject<HTMLDivElement> = React.createRef()
  menuWrapper: React.RefObject<any> = React.createRef()

  state = {
    rollingClass: getRollingClass(this.props.vertical),
    marginLeft: 0,
  }

  componentDidMount() {
    this.setState({ marginLeft: this.getMenuMarginLeft() })
    window.addEventListener('resize', this.handleResize)
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      rollingClass: getRollingClass(nextProps.vertical),
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.rollingClass !== this.state.rollingClass) {
      this.setState({ marginLeft: this.getMenuMarginLeft() })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.setState({ marginLeft: this.getMenuMarginLeft() })
  }

  getMenuMarginLeft = () => {
    const selectedIndex = pcMenus.findIndex(menu => menu.vertical === this.props.vertical)
    if (selectedIndex < 0) return 0

    const menus: HTMLElement[] = Array.from(this.menuWrapper.current.children)
    const selectedMenuOffset = menus
      .filter((menu, index) => index <= selectedIndex)
      .reduce((sum, menu) => sum + menu.offsetWidth, 0)

    const menuAreaWidth = this.getElementWidth(this.menuArea.current)
    const menuMargin = (selectedMenuOffset - menuAreaWidth) * -1
    return Math.min(menuMargin, 0)
  }

  handleMovePrev = () => {
    this.setState({ marginLeft: 0 })
  }

  handleMoveNext = () => {
    const menus: HTMLElement[] = Array.from(this.menuWrapper.current.children)
    const menusWidth = menus.reduce((sum, menu) => sum + menu.offsetWidth, 0)
    const menuAreaWidth = this.getElementWidth(this.menuArea.current)
    const marginLeft = (menusWidth - menuAreaWidth) * -1
    if (marginLeft < 0) {
      this.setState({ marginLeft })
    }
  }

  getElementWidth = (element): number => {
    const elementStyle = window.getComputedStyle ? getComputedStyle(element, null) : element.currentStyle
    const elementPadding =
      this.toNumberStyleValue(elementStyle.paddingLeft) + this.toNumberStyleValue(elementStyle.paddingRight)
    return element.offsetWidth - elementPadding
  }

  toNumberStyleValue = (value: string): number => {
    if (!value) return 0
    const sValue = value.replace('px', '')
    const nValue = Number(sValue)
    if (isNaN(nValue)) return 0
    return nValue
  }

  render() {
    const { rollingClass, marginLeft } = this.state
    const { vertical, cx } = this.props
    const lnbLinks = pcMenus.map(menu => <LnbLink key={menu.title} {...{ menu }} />)

    return (
      <div className={cx('lnb_wrap')}>
        <div className={cx('lnb')}>
          <h2 className={cx('@blind')}>메인 메뉴</h2>
          <div className={cx('menu_area', `${rollingClass}`)} ref={this.menuArea}>
            <ul className={cx('menu')} style={{ marginLeft }} ref={this.menuWrapper}>
              {lnbLinks}
            </ul>
            <a href="javascript:void(0)" role="button" className={cx('btn_prev')} onClick={this.handleMovePrev}>
              <span>왼쪽으로 이동</span>
            </a>
            <a href="javascript:void(0)" role="button" className={cx('btn_next')} onClick={this.handleMoveNext}>
              <span>오른쪽으로 이동</span>
            </a>
          </div>
          {vertical && verticalConfig[vertical].isWindow && <LnbSearch {...{ vertical }} />}
        </div>
        <span className={cx('lnb_mask')} />
      </div>
    )
  }
}
